import Vue from 'vue'
import Router from 'vue-router'
import teacherRegisterComponent from "@/components/teacher/register.vue"
import teacherLoginComponent from "@/components/teacher/login.vue"
import teacherDashboardComponent from "@/components/teacher/dashboard.vue"
import SideMenu from '@/components/SideMenu'
import SecureComponent from "@/components/Secure.vue"
import StaffMain from "@/components/Staff/Main.vue"
import StaffAttendanceMain from "@/components/Staff/Attendance/Main.vue"
import StaffAttendanceDetails from "@/components/Staff/Attendance/Details.vue"
import AddAdmin from "@/components/School/AddAdmin.vue"
import Login from "@/components/Login.vue"
import QRJuniorLogin from "@/components/QRJuniorLogin.vue"
import Dashboard from "@/components/Dashboard.vue"
import LeaderboardV1 from "@/components/LeaderboardV1.vue"
import LeaderboardV1Full from "@/components/LeaderboardV1Full.vue"
import Settings from "@/components/Settings.vue"
import DbKelasMain from "@/components/Database/Kelas/Main.vue"
import DbGroupMain from "@/components/Database/Group/Main.vue"
import DbGroupManageStudents from "@/components/Database/Group/ManageStudents.vue"
import StudentsMain from "@/components/Students/Main.vue"
import SchoolRegister from "@/components/School/Register.vue"
import DbBehaviourCategoryMain from "@/components/Database/BehaviourCategory/Main.vue"

import DbFormMain from "@/components/Database/Form/Main.vue"
import DbFormUpdate from "@/components/Database/Form/Update.vue"
import DbFormDisplayLinkQR from "@/components/Database/Form/DisplayLinkQR.vue"
import DbFormSubmissionList from "@/components/Database/Form/SubmissionList.vue"

import GroupDashboard from "@/components/Group/Dashboard.vue"
import GroupLeaderboard from "@/components/Group/Leaderboard.vue"
import GroupDashboardSingle from "@/components/Group/DashboardSingle.vue"
import GroupPositiveDetails from "@/components/Group/PositiveDetails.vue"
import GroupStudentAttendance from "@/components/Group/StudentAttendance.vue"

import NotificationsHome from "@/components/Notifications/Home.vue"

import BadgesHome from "@/components/Database/Badges/Home.vue"
import TeachersActivities from "@/components/Teachers/Activities"
import TeachersActivitiesView from "@/components/Teachers/ActivitiesView"

import SuperLogin from "@/components/Super/Login" 
import SuperHome from "@/components/Super/Home" 
import SuperSchools from "@/components/Super/Schools" 
import SuperSchoolEdit from "@/components/Super/SchoolEdit" 
import SuperSchoolViewChangePlanRequest from "@/components/Super/SchoolViewChangePlanRequest" 
import SuperItems from "@/components/Super/Items" 
import SuperTemplateAdd from "@/components/Super/TemplateAdd" 
import SuperTemplateView from "@/components/Super/TemplateView" 
import SuperCategories from "@/components/Super/Categories" 
import SuperSchoolTypes from "@/components/Super/SchoolTypes" 
import SuperTools from "@/components/Super/Tools" 

import Home from '@/components/Home'
import Manage from '@/components/Manage'
import ManageClassesHome from '@/components/Manage/Classes/Home.vue'
import ManageClassesImportDuplicate from '@/components/Manage/Classes/ImportDuplicate.vue'
import ManageStudentsHome from '@/components/Manage/Students/Home.vue'
import ManageStudentsSubmissions from '@/components/Manage/Students/Submissions.vue'
import ManageStudentsImportDuplicate from '@/components/Manage/Students/ImportDuplicate.vue'
import ManageTeachersHome from '@/components/Manage/Teachers/Home.vue'
import ManageBehaviorsHome from '@/components/Manage/Behaviors/Home.vue'
import ManageBehaviorsHome2 from '@/components/Manage/Behaviors/Home2.vue'
import ManageBehaviorsTemplates from '@/components/Manage/Behaviors/Templates.vue'
import ManageBehaviorsTagsHome from '@/components/Manage/Behaviors/TagsHome.vue'
import ManageNotificationsHome from '@/components/Manage/Notifications/Home.vue'
import ManageGroupsHome from '@/components/Manage/Groups/Home.vue'
import ManageGroupsStudents from '@/components/Manage/Groups/Students.vue'
import ManageFormsHome from '@/components/Manage/Forms/Home.vue'
import ManageFormsEdit from '@/components/Manage/Forms/Edit.vue'
import ManageFormsSubmissions from '@/components/Manage/Forms/Submissions.vue'
import Attendance from '@/components/Attendance.vue'
import OverallAnalysis from '@/components/OverallAnalysis.vue'
import OverallReporting from '@/components/OverallReporting/OverallReporting.vue'
import OverallAnalysisTest from '@/components/OverallAnalysisTest.vue'
import SubmissionDetails from '@/components/SubmissionDetails.vue'
import AttendanceDetails from '@/components/AttendanceDetails.vue'
import Leaderboard from '@/components/Leaderboard.vue'
import LeaderboardV3 from '@/components/LeaderboardV3.vue'
import LeaderboardNew from '@/components/LeaderboardNew.vue'
import LeaderboardLive from '@/components/LeaderboardLive.vue'
import LeaderboardOld from '@/components/Leaderboard_old.vue'
import TeacherActivitiesView from '@/components/TeacherActivitiesView.vue'
import UnRevoke from '@/components/UnRevoke.vue'
import ManageQR from '@/components/ManageQR.vue'
import Setup from '@/components/Setup.vue'

Vue.use(Router)

let router =  new Router({
  mode: 'history',
  routes: [
    
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { 
        guest: true
      }
    },

    {
      path: '/',
      name: 'Login',
      component: Login,
      meta: { 
        guest: true
      }
    },

    {
        path: "/qrjunior/login",
        name: "QRJuniorLogin",
        component: QRJuniorLogin,
        meta: { 
            guest: true
        }
    },
    
    {
      path: '/Home',
      name: 'Home',
      component: Home,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Manage',
      name: 'Manage',
      component: Manage,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Manage/Classes',
      name: 'ManageClassesHome',
      component: ManageClassesHome,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Manage/Classes/ImportDuplicate',
      name: 'ManageClassesImportDuplicate',
      component: ManageClassesImportDuplicate,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Manage/Students',
      name: 'ManageStudentsHome',
      component: ManageStudentsHome,
      meta: { 
        requiresAuth: true
      }
    },    
    {
      path: '/Manage/Students/Submissions',
      name: 'ManageStudentsSubmissions',
      component: ManageStudentsSubmissions,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Manage/Students/ImportDuplicate',
      name: 'ManageStudentsImportDuplicate',
      component: ManageStudentsImportDuplicate,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Manage/Teachers',
      name: 'ManageTeachersHome',
      component: ManageTeachersHome,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Manage/Behaviors',
      name: 'ManageBehaviorsHome',
      component: ManageBehaviorsHome,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Manage/Behaviors2',
      name: 'ManageBehaviorsHome2',
      component: ManageBehaviorsHome2,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Manage/Behaviors/Templates',
      name: 'ManageBehaviorsTemplates',
      component: ManageBehaviorsTemplates,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Manage/Behaviors/Tags',
      name: 'ManageBehaviorsTagsHome',
      component: ManageBehaviorsTagsHome,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Manage/Notifications',
      name: 'ManageNotificationsHome',
      component: ManageNotificationsHome,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Manage/Groups',
      name: 'ManageGroupsHome',
      component: ManageGroupsHome,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Manage/Groups/Students',
      name: 'ManageGroupsStudents',
      component: ManageGroupsStudents,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Manage/Forms',
      name: 'ManageFormsHome',
      component: ManageFormsHome,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Manage/Forms/Edit',
      name: 'ManageFormsEdit',
      component: ManageFormsEdit,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Manage/Forms/Submissions',
      name: 'ManageFormsSubmissions',
      component: ManageFormsSubmissions,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Attendance',
      name: 'Attendance',
      component: Attendance,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/OverallAnalysis40hQCw8uYpXzWUgVnSN7F0BjJL4fJScbLqehEn5uWws',
      name: 'OverallAnalysis40hQCw8uYpXzWUgVnSN7F0BjJL4fJScbLqehEn5uWws',
      component: OverallAnalysis,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/OverallAnalysisNew40hQCw8uYpXzWUgVnSN7F0BjJL4fJScbLqehEn5uWws',
      name: 'OverallReporting40hQCw8uYpXzWUgVnSN7F0BjJL4fJScbLqehEn5uWws',
      component: OverallReporting,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/OverallAnalysisNew40hQCw8uYpXzWUgVnSN7F0BjJL4fJScbLqehEn5uWws/:id',
      name: 'OverallReportingDetails40hQCw8uYpXzWUgVnSN7F0BjJL4fJScbLqehEn5uWws',
      component: OverallReporting,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/OverallAnalysisTest',
      name: 'OverallAnalysisTest',
      component: OverallAnalysisTest,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/SubmissionDetails',
      name: 'SubmissionDetails',
      component: SubmissionDetails,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/AttendanceDetails',
      name: 'AttendanceDetails',
      component: AttendanceDetails,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Leaderboard',
      name: 'Leaderboard',
      component: Leaderboard,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/LeaderboardV3',
      name: 'LeaderboardV3',
      component: LeaderboardV3,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/LeaderboardNew',
      name: 'LeaderboardNew',
      component: LeaderboardNew,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/LeaderboardLive',
      name: 'LeaderboardLive',
      component: LeaderboardLive,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Leaderboard_old',
      name: 'Leaderboard_old',
      component: LeaderboardOld,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/TeacherActivitiesView',
      name: 'TeacherActivitiesView',
      component: TeacherActivitiesView,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/UnRevoke',
      name: 'UnRevoke',
      component: UnRevoke,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/ManageQRuYEtthGl4MemU9CL14Z7vCiFXVXSXWGAFSkbuDBhM',
      name: 'ManageQRuYEtthGl4MemU9CL14Z7vCiFXVXSXWGAFSkbuDBhM',
      component: ManageQR,
      meta: { 
        requiresAuth: true
      }
    },
    {
      path: '/Setup',
      name: 'Setup',
      component: Setup,
      meta: { 
        requiresAuth: true
      }
    },
    
    {
      path: '/SideMenu',
      name: 'SideMenu',
      component: SideMenu,
      meta: { 
          guest: true
      }
    },
    {
        path: "/School/Register",
        name: "SchoolRegister",
        component: SchoolRegister,
        meta: { 
          guest: true
        }
    },
    {
        path: "/secure",
        name: "secure",
        component: SecureComponent,
        meta: { 
            requiresAuth: true
        }
    },
    {
        path: "/school/AddAdmin",
        name: "AddAdmin",
        component: AddAdmin,
        meta: { 
            requiresAuth: false
        }
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/settings",
        name: "Settings",
        component: Settings,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Database/Kelas/Main",
        name: "DbKelasMain",
        component: DbKelasMain,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Database/Group/Main",
        name: "DbGroupMain",
        component: DbGroupMain,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Database/BehaviourCategory/Main",
        name: "DbBehaviourCategoryMain",
        component: DbBehaviourCategoryMain,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Database/Group/ManageStudents",
        name: "DbGroupManageStudents",
        component: DbGroupManageStudents,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Database/Form/Main",
        name: "DbFormMain",
        component: DbFormMain,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Database/Form/DisplayLinkQR",
        name: "DbFormDisplayLinkQR",
        component: DbFormDisplayLinkQR,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Database/Form/Update",
        name: "DbFormUpdate",
        component: DbFormUpdate,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Database/Form/SubmissionList",
        name: "DbFormSubmissionList",
        component: DbFormSubmissionList,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Students/Main",
        name: "StudentsMain",
        component: StudentsMain,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/teacher/register",
        name: "teacherRegister",
        component: teacherRegisterComponent,
        meta: { 
            requiresAuth: false
        }
    },
    {
        path: "/teacher/login",
        name: "teacherLogin",
        component: teacherLoginComponent,
        meta: { 
            guest: true
        }
    },
    {
        path: "/teacher/dashboard",
        name: "teacherDashboard",
        component: teacherDashboardComponent,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Staff/Main",
        name: "StaffMain",
        component: StaffMain,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Staff/Attendance/Main",
        name: "StaffAttendanceMain",
        component: StaffAttendanceMain,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Staff/Attendance/Details",
        name: "StaffAttendanceDetails",
        component: StaffAttendanceDetails,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/LeaderboardV1",
        name: "LeaderboardV1",
        component: LeaderboardV1,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/LeaderboardV1Full",
        name: "LeaderboardV1Full",
        component: LeaderboardV1Full,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Group/Dashboard",
        name: "GroupDashboard",
        component: GroupDashboard,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Group/DashboardSingle",
        name: "GroupDashboardSingle",
        component: GroupDashboardSingle,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Group/PositiveDetails",
        name: "GroupPositiveDetails",
        component: GroupPositiveDetails,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Group/StudentAttendance",
        name: "GroupStudentAttendance",
        component: GroupStudentAttendance,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Group/Leaderboard",
        name: "GroupLeaderboard",
        component: GroupLeaderboard,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Notifications/Home",
        name: "NotificationsHome",
        component: NotificationsHome,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Database/Badges/Home",
        name: "BadgesHome",
        component: BadgesHome,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Teachers/Activities",
        name: "TeachersActivities",
        component: TeachersActivities,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/Teachers/ActivitiesView",
        name: "TeachersActivitiesView",
        component: TeachersActivitiesView,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/super/login",
        name: "SuperLogin",
        component: SuperLogin,
        meta: { 
          guest: true
        }
    },
    {
        path: "/super/home",
        name: "SuperHome",
        component: SuperHome,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/super/schools",
        name: "SuperSchools",
        component: SuperSchools,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/super/school/edit",
        name: "SuperSchoolEdit",
        component: SuperSchoolEdit,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/super/school/viewChangePlanRequest",
        name: "SuperSchoolViewChangePlanRequest",
        component: SuperSchoolViewChangePlanRequest,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/super/items",
        name: "SuperItems",
        component: SuperItems,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/super/template/add",
        name: "SuperTemplateAdd",
        component: SuperTemplateAdd,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/super/template/view",
        name: "SuperTemplateView",
        component: SuperTemplateView,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/super/categories",
        name: "SuperCategories",
        component: SuperCategories,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/super/school/types",
        name: "SuperSchoolTypes",
        component: SuperSchoolTypes,
        meta: { 
          requiresAuth: true
        }
    },
    {
        path: "/super/tools",
        name: "SuperTools",
        component: SuperTools,
        meta: { 
          requiresAuth: true
        }
    },
  ]
})


router.beforeEach((to, from, next) => {
    
    const record = to.matched.some(record => record.meta.requiresAuth);
    console.log("711 record: ")
    console.log(record)
    
    if(record) {
      if (localStorage.getItem('jwtToken') == null) {
        next({
          path: '/login',
          params: { nextUrl: to.fullPath }
        })
      } else {
        
        //$emit("authenticated", true)
        // let user = JSON.parse(localStorage.getItem('user'))
        
        // console.log("user")
        // console.log(user)
        // if(to.matched.some(record => record.meta.is_admin)) {
        //   if(user.is_admin == 1){
        //       console.log("67")
        //       next()
        //   }
        //   else{
        //     console.log("71")
        //       next({ name: 'secure'})
        //   }
        // }else {
        //     console.log("75")
        //     next()
                
        // console.log("75")
        // console.log("to:")
        // console.log(to)
        // console.log("from: ")
        // console.log(from)
        // console.log("next: ")
        // console.log(next)
        // // next({ name: 'secure'})
        next()
      }
    }else if(to.matched.some(record => record.meta.guest)) {
      console.log("752")
      if(localStorage.getItem('jwtToken') == null){
        console.log("754")
        next()
      }else{
        console.log("757")
        next()
      }
    }else {
      console.log("761")
      next() 
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js